import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { ProtectedRoute } from '@/auth';
import { useAuthorization } from '@/authorization';
import { Loading } from '@/components/Shared/Loading';
import { defaultAdminModuleId } from '@/config/adminModules';
import { routes } from '@/config/routes';
import { AdminPage } from '@/pages/Admin';
import { AdminModuleEmbedPage } from '@/pages/Admin/AdminModuleEmbedPage';
import { HomePage } from '@/pages/Home';
import { LoginPage } from '@/pages/Login';

function AdminRouteGuard() {
  const { hasPermission, isLoading } = useAuthorization();

  if (isLoading) {
    return <Loading />;
  }

  const canAccessAdmin = hasPermission('ADMIN_PORTAL_ACCESS');

  if (!canAccessAdmin) {
    return <Navigate to={routes.home} replace />;
  }

  return <Outlet />;
}

export function AppRoutes() {
  return (
    <Routes>
      <Route path={routes.login} element={<LoginPage />} />
      <Route element={<ProtectedRoute />}>
        <Route path={routes.home} element={<HomePage />} />
        <Route element={<AdminRouteGuard />}>
          <Route
            path={routes.admin}
            element={
              <Navigate to={routes.adminModule(defaultAdminModuleId)} replace />
            }
          />
          <Route path="/admin/:moduleId" element={<AdminPage />} />
          <Route
            path="/admin/embed/:moduleId"
            element={<AdminModuleEmbedPage />}
          />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to={routes.home} replace />} />
    </Routes>
  );
}
